import { css } from '@emotion/react'
import { Theme } from '@mui/material/styles'

export const liveLayersFormContainer = ({ theme }: { theme: Theme }) => css`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 100%;

  gap: ${theme.spacing(3)};
  padding-top: ${theme.spacing(1)};
`

export const liveLayersFormContent = () => css`
  height: 100%;
  overflow: auto;
`

export const liveLayersFormAccordions = ({ theme }: { theme: Theme }) => css`
  overflow: visible;
  display: flex;
  align-items: stretch;
  justify-content: start;
  flex-direction: column;
  gap: ${theme.spacing(2)};
  padding: ${theme.spacing(1)};
  padding-top: 0;
  flex: 1;
`

export const liveFeedItemMeta = ({ theme }: { theme: Theme }) => css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
  flex-shrink: 0;
`

export const liveLayerOuter = css`
  background: #ebebeb80;
  border-radius: 4px;
  padding: 8px;
  border: 1px solid #d6d6d6;
`

export const liveLayerAccordionButton = css`
  background: white;

  &:hover {
    background: #f9f9f9;
  }
`
